import { useStripe } from '@stripe/react-stripe-js';
import { defaultCountryCode } from 'constants';
import { useCheckoutV2ABTest } from 'hooks/useCheckoutV2ABTest';
import useCountry from 'hooks/useCountry';
import { useCurrency } from 'hooks/useCurrency';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const BannerContext = createContext();

export const BannerProvider = ({ children }) => {
  const [paymentRequestMethods, setPaymentRequestMethods] = useState();
  const stripe = useStripe();
  const { code } = useCurrency();
  const country = useCountry();
  const checkoutV2 = useCheckoutV2ABTest();

  const displayPaymentBanner =
    checkoutV2 &&
    (paymentRequestMethods?.applePay || paymentRequestMethods?.googlePay);

  const contextValue = useMemo(
    () => ({
      paymentRequestMethods,
      displayPaymentBanner,
    }),
    [displayPaymentBanner, paymentRequestMethods]
  );

  useEffect(() => {
    if (stripe && country !== defaultCountryCode) {
      try {
        const pr = stripe.paymentRequest({
          currency: code.toLowerCase(),
          country,
          total: {
            label: 'Qwertee order',
            amount: 1000,
          },
        });

        pr.canMakePayment().then((result) => {
          if (result) {
            setPaymentRequestMethods(result);
          }
          pr.abort();
        });
      } catch (error) {}
    }
  }, [code, country, stripe]);

  return (
    <BannerContext.Provider value={contextValue}>
      {children}
    </BannerContext.Provider>
  );
};

export const useBannerContext = () => useContext(BannerContext);
